function addResize(name){
    window.addEventListener('resize',common(name))
}
function removeResize(name){
    window.removeEventListener('resize',common(name))
}
function common(name){
    return function fu(){
        let bAntiShike=false;
        if (!bAntiShike) {
            bAntiShike = true
            setTimeout(() => {
                name.resize()
                bAntiShike = false
            }, 1000) 
        }
        
    }
}
export {addResize,removeResize}